<mat-chip-list>
    <ng-container *ngFor="let category of mainCategoryItems">
        <mat-chip *ngIf="category.isChecked">            
            {{category.name}}
            <mat-icon color="warn" matChipRemove (click)="remove(category.code)">cancel</mat-icon>            
        </mat-chip>
    </ng-container>
</mat-chip-list>

